import React from 'react';
import { DEVICE_TYPE, PAGE_LAYOUT_TYPE } from 'src/app/slice';
import {
  MarketplaceSwitcherWrapper,
  RegionSwitcherWrapper,
} from 'src/features/header/styles';
import MarketplaceSwitcher from 'src/features/header/components/MarketplaceSwitcher/MarketplaceSwitcher';
import { useChromeConfigContext } from 'src/providers/ChromeConfigContextProvider';
import { useInternalChromeConfigContext } from 'src/providers/InternalChromeConfigContextProvider';
import { AccountDropdownProvider } from 'src/features/header/components/AccountDropdown/AccountDropdownProvider';
import { RegionSwitcherProvider } from 'src/features/header/components/RegionSwitcher/RegionSwitcherProvider';
import RegionSwitcher from 'src/features/header/components/RegionSwitcher/RegionSwitcher';
import { TrimMarketplaceSwitcherPublisher } from 'src/commons/utils/metrics';
import { logger } from 'src/commons/utils/logger';

export const TrimMarketplaceSwitcher: React.VFC = () => {
  const { config: internalChromeConfig } = useInternalChromeConfigContext();
  const chromeConfig = useChromeConfigContext();
  const marketplaceSwitcher = chromeConfig.marketplaceSwitcher;
  const pageLayoutType = chromeConfig.pageLayoutType;
  const isMobile =
    chromeConfig.mobileWebSupport === 'ENABLED' &&
    internalChromeConfig.deviceType === DEVICE_TYPE.MOBILE &&
    !internalChromeConfig.forceDesktopSite;

  const hasMarketplaceSwitcher =
    (marketplaceSwitcher === undefined ||
      marketplaceSwitcher.useMarketplaceSwitcher === undefined ||
      marketplaceSwitcher?.useMarketplaceSwitcher) &&
    pageLayoutType !== PAGE_LAYOUT_TYPE.FOCUS &&
    pageLayoutType !== PAGE_LAYOUT_TYPE.FOCUS_NO_HEADER;

  // We should not render Marketplace Switcher and Region Switcher together.
  // If somehow both are set in the chromeConfig, we will bias towards keeping the
  // marketplace switcher.
  if (
    marketplaceSwitcher?.useMarketplaceSwitcher &&
    chromeConfig?.regionSwitcherEnabled
  ) {
    logger.error(
      `Both Marketplace Switcher and Region Switcher are enabled for '${window.location.pathname}'. Region Switcher will be ignored.`,
    );
    TrimMarketplaceSwitcherPublisher.publishCounterMonitor('configError', 1);
  } else {
    TrimMarketplaceSwitcherPublisher.publishCounterMonitor('configError', 0);
  }

  const hasRegionSwitcher =
    chromeConfig?.regionSwitcherEnabled &&
    !marketplaceSwitcher?.useMarketplaceSwitcher &&
    pageLayoutType !== PAGE_LAYOUT_TYPE.FOCUS &&
    pageLayoutType !== PAGE_LAYOUT_TYPE.FOCUS_NO_HEADER;

  if (!hasMarketplaceSwitcher && !hasRegionSwitcher) {
    return null;
  }

  return (
    <MarketplaceSwitcherWrapper
      isMobile={isMobile}
      isFromTrim={true}
      data-ccx-e2e-id="aac-marketplace-switcher-wrapper"
    >
      {hasMarketplaceSwitcher && (
        <MarketplaceSwitcher
          pathOverride={marketplaceSwitcher?.marketplacePath}
        />
      )}

      {hasRegionSwitcher && (
        <AccountDropdownProvider>
          <RegionSwitcherProvider>
            <RegionSwitcherWrapper>
              <RegionSwitcher />
            </RegionSwitcherWrapper>
          </RegionSwitcherProvider>
        </AccountDropdownProvider>
      )}
    </MarketplaceSwitcherWrapper>
  );
};
